import { useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [editingCategory, setEditingCategory] = useState(null);
  const [categoryForm, setCategoryForm] = useState({
    name: '',
    description: '',
    allow_homework: false,
    required_tier: 'bronze',
    lead_practitioner_id: '',
    co_lead_ids: []
  });

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/forum/categories`);
      setCategories(response.data);
    } catch (error) {
      toast.error('Failed to load categories');
    }
  };

  const resetCategoryForm = () => {
    setCategoryForm({ name: '', description: '', allow_homework: false, required_tier: 'bronze', lead_practitioner_id: '', co_lead_ids: [] });
    setEditingCategory(null);
  };

  const handleEditCategory = (category, scrollRef) => {
    setEditingCategory(category.id);
    setCategoryForm({
      name: category.name,
      description: category.description,
      allow_homework: category.allow_homework || false,
      required_tier: category.required_tier || 'bronze',
      lead_practitioner_id: category.lead_practitioner_id || '',
      co_lead_ids: category.co_lead_ids || []
    });
    scrollRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const saveCategory = async (onSuccess) => {
    try {
      const payload = { ...categoryForm, lead_practitioner_id: categoryForm.lead_practitioner_id || null };
      if (editingCategory) {
        await axios.put(`${API}/forum/categories/${editingCategory}`, payload);
        toast.success('Category updated!');
      } else {
        await axios.post(`${API}/forum/categories`, payload);
        toast.success('Category created!');
      }
      resetCategoryForm();
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error('Failed to save category');
    }
  };

  const deleteCategory = async (id, onSuccess) => {
    try {
      await axios.delete(`${API}/forum/categories/${id}`);
      toast.success('Category deleted!');
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error('Failed to delete category');
    }
  };

  return {
    categories,
    editingCategory,
    categoryForm,
    setCategoryForm,
    fetchCategories,
    resetCategoryForm,
    handleEditCategory,
    saveCategory,
    deleteCategory
  };
};

export default useCategories;
